

// should match `BookItBackend/Domain/BookingType.cs`
import {IBookingStatus} from "./bookingStatusTypes";
import {
  IOwnedVenue,
  IBlockout,
  IDiaryService,
  ITableItem,
  IBookingMenuOption,
  ISavedBookingSelectedOptions,
  StaffEditType,
} from 'shared-types/index';

export const FunctionTrackerInfo = {
  id: 'function_tracker',
  name: 'Function Tracker',
}

/**
 * @todo: it may make sense now to change 'WaitList' to 'WalkIn', since NBI-1453 made it impossible to have a waitlist
 * item unless it is either standby or walkin. This however would involve a back end change as well. severity: medium
 */
export enum BookingType {
  Booking = 'Booking',
  WaitList = 'WaitList',
  StandbyList = 'StandbyList'
}

export enum BookingBaseType {
  booking = 'booking',
  event = 'event',
  backchannel= 'backchannel'
  // @todo: determine if we also need private function here
}

export enum BookingMethods {
  phone = 'phone',
  walkin = 'walkin',
  internet = 'online',
  email = 'email',
  abc = 'abc',
  reserveWithGoogle = 'reserve-with-google',
}

export enum PaymentTypes {
  NoPayment = 'NoPayment', // Default
  Deposit = 'Deposit',
  FullPayment = 'FullPayment',
  PreAuth = 'PreAuth',
  FunctionPayment = 'FunctionPayment',
  MenuOptions = 'MenuOptions' // Only a map/type view
}
export enum BlockoutRepeatTypes {
  Close = 'close',
  NoRepeat = 'no-repeat', // Default
  Daily = 'daily',
  Weekly = 'weekly',
  Monthly = 'monthly',
  Yearly = 'yearly'
}
export enum BookingOptionTypes{
  WholeBookingOnOneOption = 1,
  QuantitiesPerOption = 2,
  BookingOptionPerBooking = 3
}
// @todo: define under bookingStatysTypes.ts as BookingStatusCodes and refactor instance. severity: medium
export enum BookingStatus {
  NoShow = 'NS'
}

export enum ViewTypes {  // used in view.actions.ts
  timeline = 0,
  floorplan = 1,
  runsheet = 2
}

// @todo: use these types to differenciate between Sms and Email communication for Standby. Severity: medium
export enum StandbyCommunicationTypes {
  Sms = 'Sms',
  Email = 'Email'
}


export interface ITableOptionValidity {
  free?: boolean;
  valid?: boolean;
}

export interface ITableOptionValidityRef extends ITableOptionValidity {
  table?: ITableItem;
}

export enum TimeStatus {
  available = 'available',
  unavailable = 'unavailable'
}


// similar to
export interface IPaymentDetails {
  menuOptions: string[]; // ["menuoption_F2CKA82APR5PH_1586299562563"]
  optionsFrom: unknown;
  optionsTo: unknown;
  paymentType: PaymentTypes;
  peopleRequired: number;
  singleMenuPerBooking: boolean;
  price?: number;
  pricingType?: string;
  discountAmount?: number;
}

/**
 * Properties for pre-auth payment type
 */
export interface IPaymentSummary {
  amount: number;
  amountDue: number;
  amountHeld: string; // "2.00"
  amountPaid: number;
  currencyCode: string;
  hasPromotion: boolean;
  paymentType: PaymentTypes;
  preAuthChargedAmount: number;
  preAuthChargeIfWithinHours: number;
  preAuthHeldDate: string; // "2022-04-19T07:34:00.2929921+00:00"
  preAuthReleasedAmount: number;
  preAuthStatus: string;
  pricingType?: string;
  transactionId?: any;
}

/**
 * Properties for non pre-auth payment type
 */
export interface IPaymentPending {
  discountAmount: number;
  fee: number;
  nbiFee: number;
  paymentType: PaymentTypes;
  peopleRequired: number;
  price: number;
  transactionFeeDescription: string;
  pricingType?: string;
}

export interface IBookingLink {
  linkName: string;
  linkURL: string;
}

// this interface is being phased out and should be replaced with shared-types IBooking wherever possible
export interface IBooking {
  sectionMaxOccupancy?: string;
  bookedAt: Date; // Thu Sep 03 2020 13:24:55 GMT+1000 (Australian Eastern Standard Time) {}
  bookingEnd: Date; // Fri Sep 04 2020 09:30:00 GMT+1000 (Australian Eastern Standard Time) {}
  bookingRef: string; //"03495357"
  partner?: string; //e.g. "Function Tracker"
  bookingMin: number;
  company: string; // "GoG"
  customerId: string; // "customer_9ea76edb-914f-4526-b3e8-bdcbc208ce91"
  customersCovid: unknown[];
  duration: string | number; // should be number (mins) but due to bug, could be string
  email: string; // "peter@quill.com"
  firstName: string; // "Peter"
  hasCustomerNotes: boolean;
  hasManagerNotes: boolean;
  notes: string;
  hasVisitedMultipleVenues: boolean;
  selectedMenuOptions?: IBookingMenuOption[];
  selectedUpsellOptions?: IBookingMenuOption[];
  selectedOptions?: ISavedBookingSelectedOptions[];
  lastModifiedDate: string; // "2020-09-03T03:24:55.403Z"
  lastName: string; //"Quill"
  locked: boolean;
  method: BookingMethods;
  orgTime: string; // "2020/09/04 09:00"
  paymentDetails: IPaymentDetails;
  paymentSummary?: IPaymentSummary;
  paymentPending?: IPaymentPending;
  people: number; // 2
  phone: string;
  preferredSectionId: string; // "section_9BTVP2I5KZMWI"
  primaryTableId: string;
  serviceId: string; // "service_MWNR2VZS6BAO1_1587075416493"
  serviceName: string;
  serviceType: string;
  standByConfirmationExpiry?: string;
  status: IBookingStatus;
  tables: ITableItem[];
  tags: IBookingTag[];
  time: Date; // Fri Sep 04 2020 09:00:00 GMT+1000 (Australian Eastern Standard Time) {}
  isStandbyListFlexibleTime?: boolean;
  type: BookingBaseType; // "booking"
  bookingType: BookingType; // 0
  sharedOverCapacity: boolean;
  overdue: boolean;
  isManualJoin: boolean;
  functionTracker?: boolean;
  _id: string; // "booking_2020-09-04_QLBY104Y0T0W2_1599103495357"
  _rev?: string; // gets added after saved to pouch
  _revisions?: object,  // object contains revisions of a doc in CouchDB
  staffName?: string;
  movedFromBookingId?: string;
  bookingLinks?: IBookingLink[];
  communicationsEnabled?: boolean;
  hasVIPCustomerSMSSent?: boolean;
  isPreAuthPayment?: boolean;
  isSingleMenuOptionService?: boolean;
  visits?: number;
  additionalPaymentDetails?: any[];
  newOnlineBooking?: boolean;
  disableEmailSmsNotification?: boolean;
}

export interface IBookingNotificationItem extends IBooking {
  modifiedProperties?: string;
  customer?: ICustomer;
  notify?: boolean;
}

export interface ICustomer {
  birthdayDate?: number;
  birthdayMonth?: number;
  birthdayYear?: number;
  company?: string;
  email: string; // "peter@parker.com"
  firstName: string; // "Peter"
  fullName: string; // "Peter Parker"
  hasVisitedMultipleVenues?: boolean;
  lastModifiedDate: string; // "2020-09-22T03:33:10.3767529+00:00"
  lastName: string; // "Parker"
  managerNotes: string;
  noShowCount: number;
  notes: string;
  phone: string;// "+61414000111"
  phone2: string;
  phoneNational: string; //"0414562166"
  postcode: string;
  streetAddress: string;
  subscribed: boolean;
  suburb: string;
  tags: IBookingTag[];
  type: string; // "customer"
  venueIds: number[];
  _id: string; // "customer_8b75784d-b292-46dd-bec6-ba92daa7c911"
  _rev?: string;
  id?: string; // "customer_3357019e-0254-4127-a0e8-634e5fc5cb9b"
  _deleted?: boolean;
  label?: string;
  temporary?: boolean;
  customerType?: string;
}

export interface IResponse<T> {
  statusText: string; // OK
  status: number; // 200
  data: T;
}

export interface IVenue {
  id: number; //9
  accountId: string; //"109d9819-d0ee-479c-87b8-855f8bbfb266"
  active: boolean;
  additionalBookingRequirements?: {
    requiresVerification: boolean;
    verificationHeader: string; //"Vaccination Verification"
    verificationMessage: string; // "Dear Guests Under the Governments Public Health Orders, you and ALL your guests, will be required to be double vaccinated to dine with us. All guests will be required to show proof of their vaccinations upon arrival."
  };
  address: string; //"20 Mascot Street, , Woy Woy, NSW, Australia, 2256"
  alternativePhone: string; //null
  couchName: string; //"db9"
  couchUrl: string; //"http://10.211.55.3:5984/db9"
  country: string; //"AU"
  createdAt: string; //"2020-04-01T06:39:37.5265894+00:00"
  currency?: string; //"AUD"
  email: string; //"jim@nowbookit.com"
  enableSmsWaitList: boolean;
  isCovidGuestMode: boolean;
  isGiftCardActive: boolean;
  isOnlineCustomersEnabled: boolean;
  isPOSActive:boolean;
  isPaymentsConfigured: boolean;
  isTakeAwayMode: boolean;
  isTelemetryEnabled: boolean;
  maxBookingOptionsPerInterval: number;
  maxPeoplePerOnlineBooking: number;
  name: string; //"Pangolin Dreams"
  password: string; // null
  phone: string; //"+61 414 000 111"
  pins: string[];
  postcode: string; //"2000"
  reducedCouchName: string; //"db9r"
  reducedCouchPassword: string; //null
  reducedCouchUrl: string; //"http://10.211.55.3:5984/db9r"
  reducedCouchUsername: string; //null
  renewalDate: string; //"2020-04-01T06:39:29.482+00:00"
  standByList: boolean;
  state: string; //"NSW"
  subscriptionType: string; //"Perpetual"
  suburb: string; //"Woy Woy"
  tags: IBookingTag[];
  timeZoneId: "Australia/Sydney"
  url: string; //null
  username: string; //null
  smsEnabled:boolean;
  accentColour?: string;
  activeModifiedAt?: string; //"2019-12-12T22:15:50.4330711+00:00"
  font?: string;
  isUsingAccountWidgetSettings?: boolean;
  theme?: string;
  widgetVersion?: number;
  posIntegrations?: IPosIntegationDetails[]
}

export interface IBookingTagType {
  _id?: string; // "tagtype_shared",
  type: string; // "tagtype",
  name: string; // "Shared"
  id?: string;
}

export interface IPosIntegationDetails {
  posVendorName: string,
  markLocationBookingsLocked: boolean
}

export interface IBookingTag {
  colour?: string; //"#000000"
  icon: string; //"birthday"
  name: string; //"Birthday"
  online: boolean;
  order?: number;
  permanent?: boolean;
  tagtype: IBookingTagType;
  type?: string; // "tag"
  _id?: string; // "tag_birthday"
  selected?: boolean;
  editable?: boolean;
  noneditable?: boolean;
  _rev?: string;
}

export interface IServiceInterval  {
  intervalDuration: string; // "5";
  times: string; // "12:30 pm";
  values: string; // "";
}

// export interface IDiaryService {
// IDiaryService moved to shared-types/DiaryTypes.ts
// }

export interface IBookingTime {
  vaildTablesAtTime: ITableItem[];
  vaidJoinsAtTime: ITableItem[];
  freeTablesAtTime: ITableItem[];
  invalidTablesAtTime: ITableItem[];
  table: ITableItem;
  bookingsAtTime: unknown[];
  coversReached: number;
  errorMgs: string[];
  maxCovers: number;
  open: boolean;
  service: string; // "Afternoon"
  status: TimeStatus; // "unavailable"
  time: Date; // Mon Sep 07 2020 15:10:00 GMT+1000 (Australian Eastern Standard Time) {}
  warningMsgs: string[];
}

export enum ServiceEventType {
  PrivateFunction = 'PrivateFunction',
  Event = 'Event'
}

export interface IEvent {
  eventType: ServiceEventType;
  description: string;
  additionalPaymentDetails: unknown[];
  date: Date | string;
  firstBookingTime: Date;
  boookingInterval: string; // '30'
  bookingDuration: number; // 60
  people?: number;
  customerId: string;
  firstName: string;
  lastName: string;
  company: string;
  email: string;
  phone: string;
  _id?: string;
  _rev?: string;
  paymentDetails: IPaymentDetails;
  lastBookingTime: Date;
  startTime: Date;
  endTime: Date;
  startDateTime: Date | string;
  endDateTime: Date | string;
  type: string;
  name?: string;
}


export enum CustomerTypes {
  inline = 'inline',
  new = 'new',
  existing = 'existing'
}

export interface ILayout {
  name: string;
  sectionId: string;
  tables: ITableItem[];
  order: number;
  tablesJoins: unknown[];
  structures: unknown[];
  _id: string;
  box: { h: number, w: number, x: number, y: number, x2: number, y2: number };
}

export interface IAdditionalPaymentDetails {
  discountPercentage: number; // 90
  menuOptions: string[] // ["menuoption_EJUCQOQA94JTG_1587697160128"]
  optionsFrom: string; // "2021/03/23 00:00"
  optionsTo: string; // "2021/03/30 00:00"
  paymentType: PaymentTypes;
  peopleRequired: number; // 1
  promotionCode: string; // "halfprice"
  singleMenuPerBooking: boolean;
}

export interface IServiceItem extends IDiaryService {
  // extending IDiary service to make sure no incompatible
  // enableCustomPaxPerIntervals: boolean;
  // maxCoversPerInterval: number;
  // maxBookingsPerInterval: number;
}
export interface ICustomeDuration {
  bookingDuration: Number;
  maxPeople: Number;
  minPeople: Number;
}
export interface ISectionLayoutItem {
  sectionId: any;
  sectionNotUsed: boolean;
  layoutId: string;
  sectionClosed?: boolean;
}

export interface IServiceLayoutItem {
  name: string; // "All day"
  serviceIndex: number; // 0
  serviceId: string; //"service_MWNR2VZS6BAO1_1587075416493"

  endMin: number; // 1320
  endTime: string; // Fri Sep 04 2020 22:00:00 GMT+1000 (Australian Eastern Standard Time) {}
  layoutId: string; // "layout_VWN60GYEO62GN"
  sectionClosed: boolean;
  sectionId: string; // "section_9BTVP2I5KZMWI"
  sectionNotUsed: boolean;
  sectionOpen: boolean;
  startMin: number; // 360
  startTime: string; // Fri Sep 04 2020 06:00:00 GMT+1000 (Australian Eastern Standard Time) {}
  totalMin: number; // 960
}

export interface ISchedule {
  _id: string; // "schedule_day_5_49O725W7J5F15_2020-08-19"
  services: IServiceItem[];
  isOpen: boolean;
  serviceLayouts?: IServiceLayoutItem[];

  blockouts?: IBlockout[];
  boookingInterval: number; //15
  dayName: string; // "Friday"
  dayNum: number; // 5
  order: number; // 2
  date?: any;
}

/** Contains the amount details spend by a customer for a specific venue */
export interface IAmountSpendInfo {
  averageSpend: number;
  customerId: string;
  totalSpend: number;
}

/** Contains the items purchased by the customer till date */
export interface IPurchasedItemInfo {
  transactionDateTime: string;
  sku: string;
  productName: string;
  description: string;
  quantity: string;
  unitPrice: number;
  salesCategoryName: string;
  customerId: string;
  Id: string;
  Expr1: string;
}

export enum ApiStatus {
  isOnline = 'isOnline', // api is reachable
  isOffline = 'isOffline'
}

export enum CouchEndpointStatus {
  isReachable= 'isReachable', // remote couch db is reachable
  isUnreachable= 'isUnreachable'
}

export enum CouchStatus { // various states of couch, which can be for remote or local db
  setup = 'setup',
  online = 'online',// @todo: I think we can remove 'online', since 'uptodate' gets used instead. severity: medium
  offline = 'offline',
  sending = 'sending',
  receiving = 'receiving',
  syncing = 'syncing',
  uptodate = 'uptodate',
}


export enum ReplicationEventType {
  uptodate = 'uptodate',
  error = 'error',
  change = 'change',
  // offline = 'offline',
}

// must match the vm.customer properties
export enum SEARCH_FIELDS {
  FIRST_NAME = 'firstName',
  LAST_NAME = 'lastName',
  PHONE = 'phone',
  EMAIL = 'email',
  COMPANY = 'company'
}

export enum AustralianStates {
  VIC = 'VIC',
  TAS = 'TAS',
  QLD = 'QLD',
  WA = 'WA',
  SA = 'SA',
  NT = 'NT',
  ACT = 'ACT',
  NSW = 'NSW',
}

export interface IPouchDBInstance {
  allDocs?: (param: any) => any;
  put?: (param: any) => any;
  get?: (param: any) => any;
  remove?: (param: any) => any;
  bulkDocs?: (param: any) => any;
}

export interface IPouchService {
  selectDatabase?: (date: Date | string) => IPouchDBInstance;
  getDBOnline?: () => IPouchDBInstance;
  getDB?: () => IPouchDBInstance;
  getDBOnlineReducedAsFirstOption?: () => IPouchDBInstance;
  getNewOfflineBookingsInstance?: () => IPouchDBInstance;
  getNewId?: (param: any) => any;
}

export interface IGeneralSettingsCache {
  diaryRollover?: boolean;
  enableEndBookingTime?: boolean;
  highlightConflicts?: boolean;
  highlightConflictsMins?: number;
  highlightMaxCoversPerInterval?: boolean;
  highlightOverdue?: boolean;
  highlightOverdueMins?: number;
  staffEnabled?: boolean;
  staffRequiredCreateEvent? : boolean,
  staffRequiredEditEvent? : boolean,
  staffRequiredCreateBlockout? : boolean,
  staffRequiredEditBlockout? : boolean
  enableRecurringBookings?: boolean;
  _id?: string;
  _rev?: string;
  staffEditEnabled?: boolean;
  staffEditRequired?: boolean;
  staffEdit?: StaffEditType;
  companyNameFirst?: string;
}

// search service option
export enum SEARCH_DATE_OPTIONS {
  ALL= 'All',
  DAY= 'Day',
  FUTURE= 'Future'
}

export interface IAccount {
  accentColour?: string; // "hex,512da8,ffff00"
  accountId?: string;
  accountPhone: string; // "+61 414 888 999"
  active: boolean;
  alternativePhone: string;
  businessAddress: string;
  businessId: string;
  businessName: string;
  businessUrl: string;
  contactNumber: string; // "+61414666555"
  country: string; // "AU"
  createdAt?: string;// "2019-08-22T05:22:59.0148094+00:00"
  currentBookingService: unknown;
  email: string;
  firstName: string;
  font?: string; //
  surname: string;
  id: string; // "109d9819-d0ee-479c-87b8-855f8bbfb266"
  phone?: string;//
  pin?: any;
  logoUrl: string;
  ownedVenues: IOwnedVenue[];
  postcode: string;
  roles?: {
    name: string;
  }[];
  state: string;
  suburb: string;
  theme?: string;// "light"
  venues?: IVenue[];
  widgetVersion?: number;// 2
}

export interface IOption {
  price: number;
  childOptions?: IOption[];
}

export interface IAdminService {
  getVenue?: (...param: any) => any;
  getSharedTagsEndpointsURL?: (...param: any) => any;
  getVenueEndpointURL: () => string;
  getSearchCustomerEndpointsURL: (param: boolean) => string;
  isManager?: boolean;
}

export enum AdminServiceLog {
  ERRORLOG= 'error',
  WARNLOG= 'warn',
  INFOLOG= 'info',
}

export enum NgLocalStorageKey {
  isManager = 'isManager',
  accountLocked = 'accountLocked',
  account = 'account',
  venue = 'venue',
  couchUsers = 'couchUsers',
  runSheetCols = 'runSheetCols',
  showEmptyTables = 'showEmptyTables',
  allBookings = 'allBookings',
  waitList = 'waitList',
  standbyList = 'standbyList',
  NBIReleaseVersion = 'NBIReleaseVersion',
  token = 'token',
  isLegacyLogin = 'isLegacyLogin',
  event = 'event',

  spamBooking = 'spamBooking',
  spamBookingTime = 'spamBookingTime',
  activeRoute = 'activeRoute',
}

export interface DocUpdateEvent {
  name: string;
  targetScope: ng.IScope;
  preventDefault: Function;
  defaultPrevented: boolean;
  currentScope: ng.IScope;
}
export interface IBookingAlert {
  body: string;
  bookingId?: string;
  dateAndTime: string;
}
export interface IBackChannelBooking extends IBooking {
  alerts: IBookingAlert[];
}

export interface IPouchRowItem<T> {
  id: string;
  key:string;
  value: {rev: string;};
  doc: T;
}

export interface IPouchRows<T> {
  total_rows: number;
  offset: number;
  rows: IPouchRowItem<T>[];
}

export interface IPouchUpdateResponse {
  id: string;
  rev: string;
  ok: boolean;
}

export enum ChangeLogOperation {
  DeleteData = 'Delete',
  AddData = 'Add',
  ChangeData = 'Change',
  NewData = 'New',
  RemoveData = 'Remove'
}

export enum LoginRoutes {
  login = 'login',
  directLogin = 'direct-login',
  oauth2DirectLogin = 'oauth2-direct-login',
  supportLogin = 'support-login',
  supportOAuth2Login = 'support-oauth2-login',
  adminLogin = 'admin-login',
  oauth2 = 'oauth2',
  logout = 'logout',
}


export interface ICoversBySection {
  sectionCovers: number;
  sectionMarker: string;
}


export interface ISectionPosition {
  x: number;
  y: number;
}

export interface ISectionMaxOcc { // was ISection
  name: string; // "Main Room"
  order: number; // order in list compared with other sections
  position: ISectionPosition;
  type: string; //"section"
  maxOccupancy?: number;
  _id: string; // section_GIYOEZ9CC963K
}


export interface IScheduleInterval {
  breached?: number; // 0
  coversReached?: number; // 0
  maxCovers?: number; // undefined
  time: Date; // Tue Nov 24 2020 06:00:00 GMT+1100 (Australian Eastern Daylight Time) {}
  warning?: number; // 0
  coversTotal?: number;
  coversBySection?: Map<string, ICoversBySection>;
}

export enum MaxOccupancyType {
  none = 'none',
  safe = 'safe',
  danger = 'danger',
  exceeded = 'exceeded'
}

export const INVALID_DATE = 'Invalid date';
